import { AlertBannerType, AlertBannerVariant, ExAlertBanner } from '@boomi/exosphere';
import styles from './ErrorAlertBanner.module.css';

interface ErrorAlertBannerProps {
    children: React.ReactNode;
    className?: string;
    onClose?: () => void;
}

const ErrorAlertBanner = ({ children, className, onClose = () => {} }: ErrorAlertBannerProps) => (
    <ExAlertBanner
        type={AlertBannerType.ERROR}
        open
        variant={AlertBannerVariant.INLINE}
        onClose={onClose}
        className={className}
    >
        <span className={styles.message}>{children}</span>
    </ExAlertBanner>
);

export default ErrorAlertBanner;
